module.exports = __webpack_public_path__ + "img/chanceofthunderstorm.e8580b40.png";